import { render, staticRenderFns } from "./Contact-Detail-Overview.vue?vue&type=template&id=120c5092"
import script from "./Contact-Detail-Overview.vue?vue&type=script&lang=js"
export * from "./Contact-Detail-Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports